var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCamperBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 54 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42639 2H49.9368C50.3698 2 50.7519 2.30565 50.8793 2.71319L51.7453 5.7952C51.8726 6.22821 51.5415 6.66123 51.1085 6.66123L46.3709 6.73764L51.4906 17.5884C51.8217 18.3016 52 19.0657 52 19.8553V24.8732C52 26.0958 51.0066 27.0892 49.784 27.0892H4.36882C3.73204 27.0892 3.1462 26.6816 2.94243 26.0703L2.25471 24.109C2.07641 23.6251 2 23.0902 2 22.5807V3.40092C2 2.63678 2.63678 2 3.42639 2Z",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7798 31.6485C14.1713 31.6485 16.1099 29.7098 16.1099 27.3184C16.1099 24.9269 14.1713 22.9883 11.7798 22.9883C9.38836 22.9883 7.44971 24.9269 7.44971 27.3184C7.44971 29.7098 9.38836 31.6485 11.7798 31.6485Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4917 31.6485C45.8832 31.6485 47.8218 29.7098 47.8218 27.3184C47.8218 24.9269 45.8832 22.9883 43.4917 22.9883C41.1003 22.9883 39.1616 24.9269 39.1616 27.3184C39.1616 29.7098 41.1003 31.6485 43.4917 31.6485Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0668 7.4762H42.7015C43.0326 7.4762 43.3128 7.67996 43.4402 7.96014L46.0128 14.0732C46.2675 14.6845 45.8345 15.3468 45.1722 15.3468H34.0922C33.6592 15.3468 33.2772 14.9902 33.2772 14.5317V8.2658C33.2517 7.83279 33.6083 7.4762 34.0668 7.4762Z",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67894 7.4762H15.0147C15.2184 7.4762 15.3967 7.65449 15.3967 7.85826L15.4477 12.8252C15.4477 13.0289 15.2694 13.2072 15.0656 13.2072H7.70442C7.50065 13.2072 7.32235 13.0289 7.32235 12.8252V7.85826C7.29688 7.62902 7.4497 7.4762 7.67894 7.4762Z",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8085 7.4762H29.1764C29.6603 7.4762 30.0424 7.85826 30.0424 8.34221L30.0933 27.1145H21.968V8.31674C21.9425 7.85826 22.3246 7.4762 22.8085 7.4762Z",
    stroke: "#020203",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCamperBlack);
export default __webpack_public_path__ + "static/media/ico_camper_black.0ca2abe5c552a8d7e2290f61bdfcfec1.svg";
export { ForwardRef as ReactComponent };